export default "__VITE_ASSET__FTl6lGX3__"